module.exports = __webpack_public_path__ + "c8377a6a.png";


//////////////////
// WEBPACK FOOTER
// ./images/phone_graphic.png
// module id = 2754
// module chunks = 15